import { Button } from './Button'

export interface TablePaginationProps {
  /** Resumo já formatado (ex.: "1–20 de 137"), i18n do chamador. */
  readonly summary: string
  readonly canPrev: boolean
  readonly canNext: boolean
  readonly onPrev: () => void
  readonly onNext: () => void
  readonly prevLabel: string
  readonly nextLabel: string
}

/** Controles de paginação (resumo + anterior/próxima) para as tabelas de dados. */
export function TablePagination({
  summary,
  canPrev,
  canNext,
  onPrev,
  onNext,
  prevLabel,
  nextLabel,
}: TablePaginationProps) {
  return (
    <div className="flex items-center justify-between text-sm text-foreground-muted">
      <span>{summary}</span>
      <div className="flex gap-2">
        <Button variant="secondary" size="sm" disabled={!canPrev} onClick={onPrev}>
          {prevLabel}
        </Button>
        <Button variant="secondary" size="sm" disabled={!canNext} onClick={onNext}>
          {nextLabel}
        </Button>
      </div>
    </div>
  )
}
